import apiCall from "../../axios";
import config from "../../../config/config";

import IApiV2Response from "@/data/interfaces/apiV2Response";
import IUserLogExtended from "@/data/interfaces/userLogExtended";
import { UserLogExtendedActionEventTypes } from "@/data/enums/userLogExtended.enums";
export default async function logUserAction(eventType: UserLogExtendedActionEventTypes, note?: string): Promise<boolean> {
  const response = await apiCall<IApiV2Response<IUserLogExtended>>(
    "POST",
    "/api/v2/user-log-extended/log-user-action",
    {
      eventType,
      note
    },
    config.api.replace("/v1", "")
  );
  return !!response.data.data?.id;
}
